import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import logo from "../images/oi_logo.png";
import { logout } from "../actions/users";

const Header = ({ auth: { isAuthenticated, loading, user }, logout }) => {
 
  const guestNav = (
    <div className="header-wrapper">
      <div className="container-fluid">
        <div className="header-content">
          <div className="header-logo-wrapper">
            <img className="header-logo-icon" src={logo} alt="oi_icon" />
            <h4 className="header-logo-text">Oi_codebootcamp</h4>
          </div>
          {isAuthenticated && (
            <div className="header-links-wrapper">
              <div className="search-wrapper">
                <input
                  type="search"
                  name="search"
                  id="search"
                  placeholder="Search..."
                />
                <i className="las la-search"></i>
              </div>
              <div className="notification-wrapper">
                <i className="las la-bell notification-icon"></i>
              </div>
              <div className="profile-info-wrapper">
                <div className="profile-user">
                  <i className="las la-user"></i>
                  <span>{user.username}</span>
                </div>

                <div className="profile-settings-wrapper">
                  <button
                    onClick={logout}
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      color: "#f8f8f8",
                      padding: "0px",
                      margin: "0",
                      alignSelf: "center",
                      fontSize: "25px",
                    }}
                  >
                    <i className="las la-sign-out-alt"></i>
                  </button>
                </div>
              </div>
            </div>
          )}
          {/* <div className="search-wrapper">
            <Link to='/about'>About</Link>
          </div> */}
        </div>
      </div>
    </div>
  );

  const authNav = (
    <div className="header-wrapper-two">
      <ul className="header-two-links">
        <li className="header-two-links-item">
          <Link className="header-two-links-item-content" to="/dashboard">
            <i className="las la-tachometer-alt"></i>
            <span>Dashboard</span>
          </Link>
        </li>
        <li className="header-two-links-item">
          <Link className="header-two-links-item-content" to="/transactions">
            <i className="las la-book"></i>
            <span>Transactions</span>
          </Link>
        </li>
        <li className="header-two-links-item">
          <Link className="header-two-links-item-content" to="/transactions">
            <i className="las la-users"></i>
            <span>Users</span>
          </Link>
        </li>
        <li className="header-two-links-item">
          <Link className="header-two-links-item-content" to="/vouchers">
            <i className="las la-credit-card"></i>
            <span>Vouchers</span>
          </Link>
        </li>
      </ul>
    </div>
  );

  return (
    <Fragment>
      <div className="top-header-wrapper">
        {guestNav}
        {!loading && isAuthenticated && user.admin_level >= 1 && authNav}
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state) => ({
  auth: state.users,
  user: state.users.user
});
export default connect(mapStateToProps, { logout })(Header);
